import 'font-awesome/css/font-awesome.css';
import 'react-tippy/dist/tippy.css';
import './custom.scss';
import '@janus.team/janus-particles/dist/esm/janus-particles.css';
import '@janus.team/janus-copilot/esm/janus-copilot.css';
import '@rss-eng/design-tokens/build/css/variables.css';

import React from 'react';
import ReactDOM from 'react-dom';

import AppWithRouter from './app.js';

ReactDOM.render(
  <React.StrictMode>
    <AppWithRouter />
  </React.StrictMode>,
  document.getElementById('root')
);

